import { render } from "./AppLabelOnline.vue?vue&type=template&id=a1fa6b92"
import script from "./AppLabelOnline.vue?vue&type=script&lang=js"
export * from "./AppLabelOnline.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Domain\\repos\\quizup.top\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__